import React, { useMemo } from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import ru from 'date-fns/locale/ru';
import getTheme from '../theme';

// The approved design is light only, so there is no mode switch: one theme for the whole app.
// The provider name is kept from the earlier draft so index.js stays unchanged.
export const ThemeModeProvider = ({ children }) => {
  const theme = useMemo(() => getTheme(), []);
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ru}>
        {children}
      </LocalizationProvider>
    </ThemeProvider>
  );
};

export default ThemeModeProvider;
